var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":"View"}},[_c('feather-icon',{staticClass:"cursor-pointer",attrs:{"icon":"EyeIcon"},on:{"click":function($event){return _vm.$router.push({
        name: 'PostEntry',
        params: { id: _vm.data.item.id }
      })}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }